import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_PROVIDER_WORKFLOW_MONITORING } from "../../routes";
import { debug } from "../../utils/helpers";

const toISOStart = (d) => (d ? new Date(`${d}T00:00:00Z`).toISOString() : "");
const toISOEnd = (d) => (d ? new Date(`${d}T23:59:59.999Z`).toISOString() : "");

const normalizeRows = (rows) =>
  (rows || []).map((r, i) => ({
    id: r.rowKey ?? String(i),
    PartitionKey: r.partitionKey ?? "",
    RowKey: r.rowKey ?? "",
    CreationDate: r.creationDate ?? "",
    LastModificationDate: r.lastModificationDate ?? "",
    SourceFile: r.sourceFile ?? "",
    Status: r.status ?? "",
  }));

export default function useGetProviderWorkflowMonitoring(auto = false) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getProviderWorkflowMonitoring = async (
    uiFilters = {},
    pageNumber = 1,
    pageSize = 25,
    showLoader = true,
    options = {},
  ) => {
    setIsLoading(showLoader);

    const payload = {
      pageNumber,
      pageSize,
      rowKeyContains: (uiFilters.rowKey || "").trim(),
      fromCreation: toISOStart(uiFilters.creationDate || ""),
      toCreation: toISOEnd(uiFilters.creationDate || ""),
      fromLastModification: toISOStart(uiFilters.lastModificationDate || ""),
      toLastModification: toISOEnd(uiFilters.lastModificationDate || ""),
      sourceFileContains: (uiFilters.sourceFile || "").trim(),
      status: (uiFilters.status || "").trim(),
      sortColumn: options.sortOption?.sortColumn || "CreationDate",
      direction: options.sortOption?.direction || "asc",
    };

    try {
      const response = await Api.post(
        API_ROUTE_PROVIDER_WORKFLOW_MONITORING,
        payload,
      );
      const page = response?.data || {};

      const serverRows = page.data ?? page.Data ?? [];
      const serverTotal =
        page.totalRecords ?? page.TotalRecords ?? page.total ?? page.Total ?? 0;

      const normalized = normalizeRows(serverRows);

      setItems(normalized);
      setTotal(serverTotal);

      return { rows: normalized, total: serverTotal };
    } catch (err) {
      debug?.log?.(err);
      setItems([]);
      setTotal(0);
      return { rows: [], total: 0 };
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (auto) getProviderWorkflowMonitoring();
  }, [auto]);

  return { items, total, isLoading, getProviderWorkflowMonitoring, setItems };
}
